export default "__VITE_ASSET__BbDYgb7O__"